import { render, staticRenderFns } from "./SpetsglansCombinedParts.vue?vue&type=template&id=0e8e164e&scoped=true"
import script from "./SpetsglansCombinedParts.vue?vue&type=script&lang=js"
export * from "./SpetsglansCombinedParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e164e",
  null
  
)

export default component.exports